import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

const OMNI_CLUSTER_ONBOARDING_SCRIPT_QUERY_KEY =
  'omni-cluster-onboarding-script';

const getClusterOnboardingScriptQueryKey = (clusterId: string) =>
  [OMNI_CLUSTER_ONBOARDING_SCRIPT_QUERY_KEY, clusterId] as const;

const getClusterOnboardingScriptQueryOptions = ({
  clusterId,
  enabled,
  organizationId,
}: {
  clusterId: string;
  enabled: boolean;
  organizationId: string | undefined;
}) =>
  queryOptions({
    queryKey: getClusterOnboardingScriptQueryKey(clusterId),
    queryFn: async () => {
      const { data } = await apiClient.omni.getClusterOnboardingScript({
        organizationId: organizationId!,
        id: clusterId,
      });

      return data.script;
    },
    enabled: enabled && !!clusterId && !!organizationId,
  });

export const useGetClusterOnboardingScriptQuery = ({
  clusterId,
  enabled = true,
}: {
  clusterId: string;
  enabled?: boolean;
}) => {
  const { currentOrganization } = useOrganizations();

  const {
    data: script,
    isLoading,
    error,
    refetch,
  } = useQuery(
    getClusterOnboardingScriptQueryOptions({
      clusterId,
      enabled,
      organizationId: currentOrganization?.id,
    })
  );

  return {
    script,
    isLoading,
    error,
    refetch,
  };
};
